import React, { Fragment } from "react";

import { FlyoutCategory } from "@redux/modules/value/flyoutCategories/flyoutCategories.types";

import { SubmenuItem } from "./subMenuItem.component";

type SubmenuProps = {
    subCategories: Array<FlyoutCategory>;
    root?: boolean;
    level?: number;
    onClick: (active: boolean, item: Object) => void;
};

const Submenu = ({ subCategories, root, level = 0, onClick }: SubmenuProps) => {
    return (
        <Fragment>
            {subCategories.map((element: any, index: number) => (
                <SubmenuItem
                    item={element}
                    onClick={onClick}
                    level={level + 1}
                    root={root}
                    key={index}
                />
            ))}
        </Fragment>
    );
};

export { Submenu };
